export default function getResource(label) {
    const resources = { pleaseUpdateInfoMessage: 'Veuillez mettre vos renseignements à jour' };

    return resources[label];
}
